import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Modal from 'components/modal';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

import { Body, Header, ItemText, StyledPicture } from './modal-item-unavailable.styled';
import { IModalItemUnavailableViewProps } from './types';

export const ModalItemUnavailableView: FC<React.PropsWithChildren<
  IModalItemUnavailableViewProps
>> = ({
  handleContinue,
  handleChangeStore,
  unavailableItemName,
  header,
  image,
  selectNewBtnText,
  continueBtnText,
  body,
  imageAlt,
  hideSelectNewBtn,
}) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Modal
      amplitudeEventData={{
        modalAppearanceEventMessage: 'Static menu item unavailable',
      }}
      testID="item-unavailable-static-menu"
      allowsDismiss={false}
    >
      <Header fontSize={isDesktop ? '4xl' : '3xl'}>{header}</Header>
      <Body>{body}</Body>
      <StyledPicture alt={imageAlt} image={image} />
      <ItemText fontSize={isDesktop ? 'xl' : 'md'}>{unavailableItemName}</ItemText>
      <Box flexDirection="column" margin={`32px 0 0`}>
        <Box width="100%" justifyContent="center" alignItems="center" margin="0 0 1rem">
          <ActionButton fullWidth onPress={handleContinue}>
            {continueBtnText}
          </ActionButton>
        </Box>
        {!hideSelectNewBtn && (
          <Box width="100%" justifyContent="center" alignItems="center" margin="0">
            <ActionButton
              fullWidth
              variant={ActionButtonVariants.OUTLINE}
              onPress={handleChangeStore}
            >
              {selectNewBtnText}
            </ActionButton>
          </Box>
        )}
      </Box>
    </Modal>
  );
};
